import { useNavigate } from "react-router-dom";
import { WelcomeFrame } from "@/components/voice-onboarding/WelcomeFrame";
import { WelcomeValueCards } from "./WelcomeValueCards";
import { ONBOARD_ROUTES, VOICE_ONBOARD_STEPS } from "./steps";

/**
 * Step 1 of 7 — Welcome. The "what is Voice and why" hook: three value cards
 * resell the promise before we build the first genie. Static, no draft input.
 */
const WelcomePage = () => {
  const navigate = useNavigate();
  return (
    <WelcomeFrame
      step={1}
      steps={VOICE_ONBOARD_STEPS}
      eyebrow="WELCOME TO HELP GENIE VOICE"
      title="Real world support. Reinvented."
      subtitle="Your genie picks up the phone, your website, anywhere, in a voice you choose, from your own knowledge. Let's build your first one. Takes a couple of minutes."
      showBack={false}
      continueLabel="Build my genie"
      ctaPlacement="inline"
      onContinue={() => navigate(ONBOARD_ROUTES[1])}
      onSkip={() => navigate("/genies")}
    >
      <WelcomeValueCards />
    </WelcomeFrame>
  );
};

export default WelcomePage;
